import { defineMessages } from '@sm/intl';
import PROJECT_NAME from '~app/pages/Pricing/constants/project';

const COPY = defineMessages({
  SELECT: {
    id: 'Pricing.copy.Select',
    defaultMessage: 'SELECT',
    desc: {
      id: 'Pricing.copy.Select',
      message: '[Type: Button][Vis.: high] - A button/link text for an authenticated user',
      project: PROJECT_NAME,
    },
  },
  SIGN_UP: {
    id: 'Pricing.copy.SignUp',
    defaultMessage: 'SIGN UP',
    desc: {
      id: 'Pricing.copy.SignUp',
      message: '[Type: Button][Vis.: high] - A button/link text for an unauthenticated user',
      project: PROJECT_NAME,
    },
  },
  YOUR_PLAN: {
    id: 'Pricing.copy.YourPlan',
    defaultMessage: 'YOUR PLAN',
    desc: {
      id: 'Pricing.copy.YourPlan',
      message: '[Type: Button][Vis.: high] - A button/link text for an  purchased user',
      project: PROJECT_NAME,
    },
  },
  CONTACT_US: {
    id: 'Pricing.copy.ContactUs',
    defaultMessage: 'CONTACT US',
    desc: {
      id: 'Pricing.copy.ContactUs',
      message: '[Type: Button][Vis.: high] - A button/link text to contact the sales team',
      project: PROJECT_NAME,
    },
  },
});

export default COPY;
